import { UseMutationOptions, UseQueryOptions, useMutation, useQuery } from 'react-query';
import { GetTrialHistoryRequest, GetTrialHistoryResponse } from './types';
import {
  PlatformLocationFeature,
  TrialMultiSignupRequest,
  TrialMultiSignupResponse,
} from '@weave/schema-gen-ts/dist/schemas/platform-location-feature/v1/location_features.pb';
import { authorizedFetch } from 'helpers/utils';
import { AxiosError } from 'axios';
import {
  GetSubscriptionAddOnsStatusesRequest,
  GetSubscriptionAddOnsStatusesResponse,
  SubscriptionManagerService,
} from '@weave/schema-gen-ts/dist/schemas/subscription-manager-service/v1/subscription_manager_service.pb';

export const TrialSubscriptionQueryKeys = {
  baseQueryKey: ['trial-subscription'],
  getTrialHistory: (request: GetTrialHistoryRequest) => [
    ...TrialSubscriptionQueryKeys.baseQueryKey,
    'trial-history',
    request,
  ],
  getSubscriptionAddOns: (request: GetSubscriptionAddOnsStatusesRequest) => [
    ...TrialSubscriptionQueryKeys.baseQueryKey,
    'subscription-addons',
    request.locationId,
    request.requestSource,
  ],
};

export const useGetTrialHistory = <TData = GetTrialHistoryResponse>(
  request: GetTrialHistoryRequest,
  options?: UseQueryOptions<GetTrialHistoryResponse, AxiosError<any>, TData>
) => {
  return useQuery({
    queryKey: TrialSubscriptionQueryKeys.getTrialHistory(request),
    queryFn: () => PlatformLocationFeature.GetTrialHistory(authorizedFetch(), request),
    retry: false,
    ...options,
    enabled: !!request.locationId && (options?.enabled ?? true),
  });
};

export const useMultiLocationTrialSignUp = (
  options?: UseMutationOptions<
    TrialMultiSignupResponse,
    AxiosError<any>,
    TrialMultiSignupRequest
  >
) => {
  return useMutation({
    mutationFn: (request: TrialMultiSignupRequest) =>
      PlatformLocationFeature.MultiLocationsTrialSignup(authorizedFetch(), request),
    ...options,
  });
};

export const useGetSubscriptionAddOnsStatuses = <
  TData = GetSubscriptionAddOnsStatusesResponse
>(
  request: GetSubscriptionAddOnsStatusesRequest,
  options?: UseQueryOptions<GetSubscriptionAddOnsStatusesResponse, AxiosError<any>, TData>
) => {
  return useQuery({
    queryKey: TrialSubscriptionQueryKeys.getSubscriptionAddOns(request),
    queryFn: () =>
      SubscriptionManagerService.GetSubscriptionAddOnsStatuses(
        authorizedFetch(),
        request
      ),
    retry: false,
    ...options,
    enabled: !!request.locationId && (options?.enabled ?? true),
  });
};
